import {AlertList} from 'react-bs-notifier';
import createReactClass from 'create-react-class';

let AppAlert = createReactClass({
  getInitialState: function () {
    return {
      alerts: []
    };
  },

  generate(text) {
    const newAlert = {
      id: new Date().getTime(),
      type: 'success',
      headline: text,
      message: ''
    };

    this.setState({
      alerts: [...this.state.alerts, newAlert]
    });
  },

  onAlertDismissed(alert) {
    const alerts = this.state.alerts;

    // find the index of the alert that was dismissed
    const idx = alerts.indexOf(alert);

    if (idx >= 0) {
      this.setState({
        // remove the alert from the array
        alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
      });
    }
  },

  render: function () {
    return (
      <AlertList
        position="top-right"
        alerts={this.state.alerts}
        timeout={2000}
        dismissTitle="Close!"
        onDismiss={this.onAlertDismissed}
      />
    );
  }
});

export default AppAlert;
